import React, { useRef, useCallback, useState, useEffect } from 'react';
import { isString } from 'lodash';
import { format, parseISO } from 'date-fns';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';
import { useToast } from '../../../hooks/toast';

import Loading from '../../../components/Loading';
import Input from '../../../components/Input';
import SelectSync from '../../../components/SelectSync';
import getValidationErrors from '../../../utils/getValidationErrors';
import { ICupom } from '../ListaCupons';

export interface ICreateCupom {
  codigo: string;
  parceiro: string;
  tipo: number;
  valor: number;
  dataInicio: Date;
  dataFim: Date;
  maxUtilizacao: number;
}

type Props = {
  cupom?: ICupom;
  addCupom(dadosCupom: ICreateCupom): void;
};

const CupomCadastro: React.FC<Props> = ({ cupom, addCupom }) => {
  const { addToast } = useToast();

  const formRefCupom = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (cupom && cupom.dataInicio)
      formRefCupom.current?.setFieldValue(
        'dataInicio',
        format(
          parseISO(cupom.dataInicio.toString()),
          'yyyy-MM-dd HH:mm',
        ).replace(' ', 'T'),
      );
    if (cupom && cupom.dataFim)
      formRefCupom.current?.setFieldValue(
        'dataFim',
        format(parseISO(cupom.dataFim.toString()), 'yyyy-MM-dd HH:mm').replace(
          ' ',
          'T',
        ),
      );
  }, [cupom]);
  const handleSubmitCupom = useCallback(
    async (dados: ICupom) => {
      try {
        formRefCupom.current?.setErrors({});
        const schema = Yup.object().shape({
          codigo: Yup.string().required('informe o código do cupom'),
          parceiro: Yup.string().required('informe o parceiro'),
          tipo: Yup.string().min(1).required('informe tipo de cupom'),
          valor: Yup.number().required('Informe o valor'),
          dataInicio: Yup.date().required('informe a data inicial'),
          dataFim: Yup.date().required('informe a data final'),
          maxUtilizacao: Yup.number().required(
            'infome o numero máximo de cupons',
          ),
        });

        console.log(dados);
        console.log(await schema.isValid(dados));
        const retornovali = await schema.validate(dados, {
          abortEarly: false,
        });
        console.log(retornovali);

        const dadosEnvio: ICreateCupom = {
          ...dados,
          codigo: dados.codigo.toUpperCase(),
          parceiro: dados.parceiro.toUpperCase(),
          dataInicio: isString(dados.dataInicio)
            ? parseISO(dados.dataInicio)
            : dados.dataInicio,
          dataFim: isString(dados.dataFim)
            ? parseISO(dados.dataFim)
            : dados.dataFim,
          tipo: Number(dados.tipo),
        };

        await addCupom(dadosEnvio);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefCupom.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao salvar cupom',
          description: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.message,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, addCupom],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <div className="container">
      {loading && <Loading />}

      <Row noGutters>
        <Col md={12}>
          <Form
            ref={formRefCupom}
            initialData={{
              ...cupom,
              tipo: cupom?.tipo.toString() || '',
              dataInicio:
                cupom && cupom.dataInicio
                  ? format(
                      parseISO(cupom.dataInicio.toString()),
                      'dd/MM/yyyy HH:mm',
                    ).replace(' ', 'T')
                  : '',
              dataFim:
                cupom && cupom.dataFim
                  ? format(
                      parseISO(cupom.dataFim.toString()),
                      'dd/MM/yyyy HH:mm',
                    ).replace(' ', 'T')
                  : '',
            }}
            onSubmit={handleSubmitCupom}
          >
            <Row>
              <Col md={6} className="form-group pr-2">
                <Input
                  name="codigo"
                  label="Código"
                  placeholder="Blog5P"
                  type="text"
                  maxLength={15}
                />
              </Col>

              <Col md={6} className="form-group pr-2">
                <Input
                  name="parceiro"
                  label="Nome Parceiro"
                  placeholder="Blog da Medicina"
                  type="text"
                  maxLength={45}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6} className="form-group pr-2">
                <Input
                  name="dataInicio"
                  label="Início"
                  placeholder="Selecione a data e hora inicial"
                  type="datetime-local"
                />
              </Col>

              <Col md={6} className="form-group pr-2">
                <Input
                  name="dataFim"
                  label="Fim"
                  placeholder="Selecione a data e hora final"
                  type="datetime-local"
                />
              </Col>
            </Row>
            <Row>
              <Col md={4} className="form-group pr-2">
                <SelectSync
                  name="tipo"
                  options={[
                    { label: 'Percentual', value: '1' },
                    { label: 'Valor', value: '2' },
                  ]}
                  handleSelectChange={handleOnChangeVazio}
                  label="Tipo"
                />
              </Col>

              <Col md={4} className="form-group pr-2">
                <Input
                  name="valor"
                  label="Valor"
                  placeholder="5,00"
                  type="number"
                  max={50}
                />
              </Col>

              <Col md={4} className="form-group pr-2">
                <Input
                  name="maxUtilizacao"
                  label="Nº max. Cupons"
                  placeholder="100"
                  type="number"
                  max={100}
                />
              </Col>
            </Row>

            <Row className="align-items-center border-top p-1">
              <Col md="12">
                <Button type="submit" variant="success" className="mt-2">
                  Salvar dados
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default CupomCadastro;
